const _state = {
  affectedUserData: null,
  payload: null,
}
//{userId:Guid, operation:I/U} Insert o Update

export const initialState = () => _state

export const state = initialState()
